import React from 'react';
import { useState,useEffect,useCallback } from 'react';
import Alert from './Alert';
import Header from './Header';
import Talk from './Talk';
import Action from './Action';
import End from './End';
import './Voice.scss';

let tid = 0;
let step = 0;
let hasNext = true;
let isEnd = false;
let countThinking = 0;
let resultKey = null;
let active = 0;
let history = [];
let play = null;

function Voice ({uid,face,close,ajax,goResult}){
	//const [play,setPlay] = useState(null);
	const [count,setCount] = useState(0);
	const [selected,setSelected] = useState("");
	const [choices,setChoices] = useState(null);
	const [isLoading,setIsLoading] = useState(false);
	const [newTalk,setNewTalk] = useState(null);
	const [fuel,setFuel] = useState(0);
	const [isAlert,setIsAlert] = useState(false);

	const addSelected = (word)=>{
		if( selected!=="" ){
			word = " "+word;
		}
		setSelected( selected+word );
		setCount(count+1);
	};

	const submit = useCallback( ()=>{
		setIsLoading(true);
		setCount(0)
		let path = "talk/add";
		if( step===0 ){
			path = "name/add";
		}
		let id = 0;
		if( play ){
			id = play.id;
		}
		let prev = "";
		if( history.length>0 ){
			prev = history[history.length-1];
		}
		ajax(path,{text:selected,prev:prev,uid:uid,play_id:id,face:face},(res)=>{
			if( res.ok ){
				active = res.active;
				setFuel(fuel-1);
				if( step===0 ){
					if( res.play ){
						//setPlay(res.play);
						play = res.play;
					}
					step=1;
					tid = setTimeout( ()=>{
						goNext(res.talk);
					},2000);
				} else {
					startThinking();
				}
			}
		});
	},[selected,fuel,step]);

	const startThinking = ()=>{
		if( tid>0 ){
			clearTimeout(tid);
		}
		countThinking = 0;
		thinking();
	};

	const thinking = ()=>{
		let min = 1000
		if( countThinking>4 ){
			min = 3000;
		} else if( countThinking>2 ){
			min = 2000;
		}
		//console.log("min:"+min);
		tid = setTimeout( ()=>{
			ajax("talk/get",{play_id:play.id,active:active,count:countThinking},(res)=>{
				if( res.ok ){
					//console.log( res );
					if( res.talk ){
						//console.log("reply found!");
						hasNext = res.has_next;
						if(!res.has_next){
							resultKey = res.result_key;
						}
						goNext(res.talk);
					} else {
						//console.log("reply not found!");
						countThinking++;
						thinking();
					}
				}
			});
		},min );
	}
	const goNext = (talk)=>{
		setIsLoading(false);
		setNewTalk(talk);
		setFuel(fuel-2);
		tid = setTimeout( ()=>{
			isEnd = !hasNext;
			history.push(selected);
			history.push(talk);
			setNewTalk(null);
			setSelected("");
			if(hasNext){
				updateChoices();
			}
		},1000)
	}
	const retry = useCallback( ()=>{
		setCount(0);
		setSelected("");
		updateChoices();
	},[]);

	const updateChoices = ()=>{
		setIsLoading(true);
		let path = "talk/choice";
		if( step===0 ){
			path = "name/choice";
		}
		let id = 0;
		if( play ){
			id = play.id;
		}
		ajax(path,{uid:uid,play_id:id},(res)=>{
			//console.log( res );
			if( step===0 ){
				setFuel(res.fuel);
			}
			//combi = res.combi;
			setChoices(res.choices);
			setCount(1);
			setIsLoading(false);
		});
	}
	const result = useCallback(()=>{
		history.shift();
		goResult(resultKey,history);
	},[resultKey,history]);
	const bye = useCallback(()=>{
		setIsAlert(true);
	},[]);
	useEffect( ()=>{
		//console.log("useEffect");
		step = 0;
		history=["あんた誰？"];
		hasNext = true;
		isEnd = false;
		countThinking = 0;
		active = 0;
		if( tid>0 ){
			clearTimeout(tid);
			tid = 0;
		}
		resultKey = null;
		
		updateChoices();
	},[]);

	let lastCount = 0;
	if( choices ){
		lastCount = choices.length;
	}

	return (
		<div id="voice" className="panel">
			<Header close={bye}/>
			{isEnd ?
			<End
				history={history}
				face={face}
				goResult={result}
			/>
			:(
			<React.Fragment>
				<Talk
					history={history}
					newTalk={newTalk}
					selected={selected}
					count={count}
					lastCount={lastCount}
					hasNext={hasNext}
					face={face}
				/>
				<Action
					count={count}
					lastCount={lastCount}
					choices={choices}
					retry={retry}
					submit={submit}
					addSelected={addSelected}
					isLoading={isLoading}
				/>
			</React.Fragment>
			)}
			<div className="footer">
				<span className="fuel"><i className="fas fa-charging-station"></i> {fuel}</span>
			</div>
			<Alert
				message="つまりキミはこのログを閉じて新しいプレイを始めたいと言うのかな？"
				isOpen={isAlert}
				close={(answer)=>{
					setIsAlert(false);
					if( answer ){
						clearTimeout(tid);
						close();
					}
				}}
			/>
		</div>
	);
}

export default Voice;
